var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMenuWeb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2102",
    "data-name": "Group 2102",
    transform: "translate(-901 -436)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2266",
    "data-name": "Path 2266",
    d: "M16,0A16,16,0,1,1,0,16,16,16,0,0,1,16,0Z",
    transform: "translate(901 436)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "web",
    transform: "translate(899.804 434.804)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_101",
    "data-name": "Ellipse 101",
    cx: 9.665,
    cy: 9.665,
    r: 9.665,
    transform: "translate(7.53 7.53)",
    fill: "none",
    stroke: "#816920",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_102",
    "data-name": "Ellipse 102",
    cx: 4.807,
    cy: 9.666,
    rx: 4.807,
    ry: 9.666,
    transform: "translate(12.389 7.53)",
    fill: "none",
    stroke: "#816920",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_103",
    "data-name": "Ellipse 103",
    cx: 9.666,
    cy: 4.807,
    rx: 9.666,
    ry: 4.807,
    transform: "translate(7.53 12.389)",
    fill: "none",
    stroke: "#816920",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_312",
    "data-name": "Line 312",
    x2: 19.333,
    transform: "translate(7.53 17.196)",
    fill: "none",
    stroke: "#816920",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_313",
    "data-name": "Line 313",
    y2: 19.333,
    transform: "translate(17.196 7.53)",
    fill: "none",
    stroke: "#816920",
    strokeWidth: 1.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuWeb);
export default __webpack_public_path__ + "static/media/icon-menu-web.848dafdb.svg";
export { ForwardRef as ReactComponent };